(function ($) {
  $(function(){
    var $gallery = $('#lookbook #gallery'),
        $slides = $('#product_slider .slides'),
        magnifyIndex = 1,
        isMobile = false;
    
    if($gallery.length){
      
      	var $controlButtons = $gallery.find('.cycle-prev, .cycle-next');
      
      	var cursorHalf = 15;	
      	var galleryHalf = $gallery.width()/2;
      	
        $(window).on('resize', function(){
          galleryHalf = $gallery.width()/2;
        });
      
        $gallery.on('mousemove touchmove', function(event){
          if(event.type == 'touchmove'){           
            if(typeof event.originalEvent.touches !== 'undefined'){
              if(event.originalEvent.touches[0].clientX > window.innerWidth/2 - cursorHalf){
                $gallery.removeClass('show-prev').addClass('show-next');
              } else {
                $gallery.removeClass('show-next').addClass('show-prev');
              }
            }
          } else {
            if(event.offsetX > galleryHalf - cursorHalf){
              $gallery.removeClass('show-prev').addClass('show-next');
            } else {
              $gallery.removeClass('show-next').addClass('show-prev');
            }
          }
        });
           
        $gallery.on('mouseleave', function(event){
          $gallery.removeClass('show-prev').removeClass('show-next');
        });
      
      	$gallery.find('.cycle-slide img').wrap('<span class="img-zoom"><span class="zoom"></span></span>');
      	
      $('.cycle-slide img').parents('.zoom').each(function(){
        	var $zoomEl = $(this);
        	
        
          if(typeof $zoomEl.find('img').get(0) !== 'undefined'){
            magnifyIndex = ($gallery.width()/$zoomEl.find('img').get(0).naturalWidth)*2;
          }       
        
          	$zoomEl.zoom({
              magnify: magnifyIndex,
              on: 'click',
              onZoomIn: function(){
                $(this).parents('.zoom').addClass('zoomed');
                $(this).css('zIndex', '1');
                galleryHalf = $gallery.find('.zoomImg').width()/2;
              },
              onZoomOut: function(){
                $(this).parents('.zoom').removeClass('zoomed');
                $(this).css('zIndex', '-1');
                galleryHalf = $gallery.width()/2;
              },

          });
        });

    }
    
    if($slides.length){
      var productWidth = 630;
      $slides.find('li img').wrap('<span class="img-zoom"><span class="zoom"></span></span>');
      
      var slidesHalf = $slides.width()/2;
      
      $slides.find('li img').parents('.zoom').each(function(){
        	var $zoomEl = $(this);
        	
        
          if(typeof $zoomEl.find('img').get(0) !== 'undefined'){
            magnifyIndex = ($slides.width()/productWidth)*2;
          }       
        
          	$zoomEl.zoom({
              magnify: magnifyIndex,
              on: 'click',
              onZoomIn: function(){
                $(this).parents('.zoom').addClass('zoomed');
                $(this).css('zIndex', '1');
                slidesHalf = $gallery.find('.zoomImg').width()/2;
              },
              onZoomOut: function(){
                $(this).parents('.zoom').removeClass('zoomed');
                $(this).css('zIndex', '-1');
                slidesHalf = $slides.width()/2;
              },

          });
        });
    }
    
    
  });
})(jQuery);
